import { isRequired, isBankAccount } from '@helpers/validator';

const schemaCo = {
  doc_number: {
    type: 'select',
    errorMessage: ['errors.rut.select', 'errors.rut.invalid'],
    isValid: [(value) => isRequired(value)],
  },
  account_number: {
    type: 'text',
    errorMessage: ['errors.account.validNumber'],
    isValid: [(value) => isBankAccount(value)],
  },
};

export default schemaCo;
